import DataView from './DataView'
export default DataView



// WEBPACK FOOTER //
// ./src/components/DataView/index.js